import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import AISection from './components/AISection';
import TestimonialSection from './components/TestimonialSection';
import LeadCTASection from './components/LeadCTASection';
import AboutTeaser from './components/AboutTeaser';

export default function Home() {
  const { t } = useTranslation();
  const location = useLocation();

  // Handle hash navigation after page render
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const el = document.getElementById(id);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: 'smooth' });
        }, 150);
      }
    }
  }, [location.hash]);

  const websiteLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    '@id': 'https://debugin.com/#website',
    'name': 'Texio ERP',
    'url': 'https://debugin.com',
    'description': 'Complete ERP platform built exclusively for textile factories, garment manufacturers, dyeing houses, and fabric producers. Manage production, inventory, finance, HR, quality control, and supply chain — enhanced with intelligent AI-powered insights.',
    'publisher': {
      '@id': 'https://debugin.com/#organization',
    },
    'potentialAction': {
      '@type': 'SearchAction',
      'target': {
        '@type': 'EntryPoint',
        'urlTemplate': 'https://debugin.com/search?q={search_term_string}',
      },
      'query-input': 'required name=search_term_string',
    },
    'inLanguage': ['en', 'ar'],
  };

  const softwareAppLd = {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    '@id': 'https://debugin.com/#software',
    'name': 'Texio ERP',
    'applicationCategory': 'BusinessApplication',
    'operatingSystem': 'Web, iOS, Android',
    'description': 'Complete ERP system for textile manufacturing including production management, warehouse inventory, finance accounting, human resources, quality control, supply chain, and analytics dashboards — enhanced with AI-powered insights and automation.',
    'offers': {
      '@type': 'AggregateOffer',
      'lowPrice': '299',
      'highPrice': '799',
      'priceCurrency': 'USD',
      'offerCount': '3',
    },
    'aggregateRating': {
      '@type': 'AggregateRating',
      'ratingValue': '4.8',
      'reviewCount': '127',
    },
  };

  return (
    <div className="min-h-screen bg-background-50">
      <title>Texio - Complete Textile ERP | Factory Management Software</title>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(softwareAppLd) }}
      />

      <Navbar />
      <main>
        <HeroSection />
        <FeaturesSection />
        <AISection />
        <TestimonialSection />
        <LeadCTASection />
        <AboutTeaser />
      </main>
      <Footer />
    </div>
  );
}